import React, { useState, useEffect, useRef } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import { formatMoneda, validaMonto, validaSoloNumero } from "../../util/varios";
import moment from "moment";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import CartasProveedores from "./cartas/cartasProveedor";
import { use } from "react";

const TablaClientes = () => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const anio = JSON.parse(sessionStorage.getItem("anioactu"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const accbtnclientes = JSON.parse(sessionStorage.getItem("accbtnclientesc"));
  const fechaTope = moment(JSON.parse(sessionStorage.getItem("fechasistema")))
    .format("YYYY-MM-DD")
    .replace(anio.toString(), (anio - 18).toString());
  let registrado = false;
  let muni = "";
  let ciu = "";
  let valrif = 0;

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const chkNatural = useRef();
  const chkJuridico = useRef();
  const txtId = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtRazon = useRef();
  const txtDirClient = useRef();
  const txtEmailClient = useRef();
  const txtTlf1Client = useRef();
  const txtTlf2Client = useRef();
  const txtEstado = useRef();
  const txtMunicipio = useRef();
  const txtCiudad = useRef();
  const txtStatus = useRef();
  const txtLimtCredito = useRef();
  const txtMontoCredito = useRef();
  const txtOFerta = useRef();

  const cmbNacionalidad = useRef();
  const txtCedRes = useRef();
  const cmbSexo = useRef();
  const txtFechaNac = useRef();
  const txtNomResp = useRef();
  const txtApeResp = useRef();
  const txtDireccion = useRef();
  const txtEmail = useRef();
  const txtTlf1 = useRef();
  const txtTlf2 = useRef();
  const txtIrsl = useRef();
  const cmbGrupoCliente = useRef();
  const txtRetencion = useRef();

  const [body, setBody] = useState(null);
  const [habilitado, setHabilitado] = useState(true);
  const [nacnalidad, setNacnalidad] = useState();
  const [select, setSelect] = useState(1);
  const [totalr, setTotalr] = useState(0);
  const [totalact, setTotalact] = useState(0);
  const [tituloHeader, setTituloHeader] = useState("Gestionar Clientes.");
  const [valoferta, setValoferta] = useState(0);
  const [totalinc, setTotalinc] = useState(0);
  const [titulo, setTitulo] = useState("");
  const [catalogoPersona, setCatalogoPersona] = useState(false);
  const [catalogoCliente, setCatalogoCliente] = useState(false);
  const [acept, setAcept] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [valcredt, setValcredt] = useState(0);
  const [valorCredito, setValorCredito] = useState(0);
  const [activate, setActivate] = useState(false);
  const [visibleBtn, setVisibleBtn] = useState(0);
  const [ops, setOps] = useState(0);
  const [operacion, setOperacion] = useState(0);
  const [estados, setEstados] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [habilitadoNU, setHabilitadoNU] = useState(true);
  const [activo, setActivo] = useState(true);
  const [activob, setActivob] = useState(true);
  const [buscaclient, setBuscaclient] = useState(0);
  const [idclient, setIdclient] = useState(0);
  const [rifclient, setRifclient] = useState(null);
  const [operacionPer, setOperacionPer] = useState(0);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
  });

  const imprimir = () => {
    if (accbtnclientes && accbtnclientes.toString().substring(4, 5) === "1") {
      window.open(
        `${op.reportes}/clientes?afiliado=${afiliado}&reporte=ListaCliente`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
      );
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡No Posee Permiso para Realizar esta Acción!",
        icono: "error",
      });
    }
  };

  const handleInputNumChange = (event) => {
    event.preventDefault();
    validaSoloNumero(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const handleInputMonChange = (event) => {
    event.preventDefault();
    validaMonto(event);

    if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const datosRes = () => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let nomid2 = "nacionalidad";
    let id = txtCedRes.current.value;
    let id2 = cmbNacionalidad.current.value;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          cmbSexo.current.value = "";
          txtFechaNac.current.value = "";
          txtNomResp.current.value = "";
          txtApeResp.current.value = "";
          txtDireccion.current.value = "";
          txtEmail.current.value = "";
          txtTlf1.current.value = "";
          txtTlf2.current.value = "";

          if (response.data !== "") {
            if (operacion !== 2) {
              setHabilitadoNU(true);
            }
            setOperacionPer(0);
            cmbSexo.current.value = response.data.sexo;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            txtNomResp.current.value =
              response.data.nombres && response.data.nombres.trim();
            txtApeResp.current.value =
              response.data.apellidos && response.data.apellidos.trim();
            txtDireccion.current.value =
              response.data.direccion && response.data.direccion.trim();
            txtEmail.current.value =
              response.data.correoe && response.data.correoe.trim();
            txtTlf1.current.value =
              response.data.tlf1 && response.data.tlf1.trim();
            txtTlf2.current.value =
              response.data.tlf2 && response.data.tlf2.trim();
            if (!botones.consultar) {
              btnCancela.current.focus();
            } else {
              btnAcepta.current.focus();
            }
          } else {
            cmbSexo.current.focus();
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto:
                "No existe una persona con este N° de cedula porfavor registre sus datos",
              icono: "informacion",
            });
            setOperacionPer(1);
            setHabilitadoNU(false);
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "estado";
    let orden = "idestado";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setEstados(response.data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const selectMunicipios = (id) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMunicipios(response.data);
          if (
            registrado ||
            !botones.consultar ||
            !botones.modificar ||
            !botones.eliminar
          ) {
            txtMunicipio.current.value = muni;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const selectCiudad = (id) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setCiudades(response.data);
          if (
            registrado ||
            !botones.consultar ||
            !botones.modificar ||
            !botones.eliminar
          ) {
            txtCiudad.current.value = ciu;
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const blanquear = () => {
    setValcredt(0);
    setValorCredito(0);
    setTituloHeader("Gestionar Clientes.");
    setBuscaclient(0);
    setIdclient(0);
    setValoferta(0);
    setRifclient(null);
    setVisibleBtn(0);
    setActivate(false);
    setActivo(true);
    setActivob(true);
    setBody(null);
    setOperacionPer(0);
    setHabilitado(true);
    setHabilitadoNU(true);
    setMunicipios([]);
    setCiudades([]);
    setAcept(true);
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoper: true,
    });
    txtOFerta.current.checked = false;
    txtLimtCredito.current.checked = false;
    txtMontoCredito.current.value = "";
    chkJuridico.current.checked = true;
    cmbRif.current.value = "";
    txtRif.current.value = "";
    txtId.current.value = 0;
    txtRazon.current.value = "";
    txtDirClient.current.value = "";
    txtTlf1Client.current.value = "";
    txtTlf2Client.current.value = "";
    txtEmailClient.current.value = "";
    txtStatus.current.value = "";
    txtEstado.current.value = "";
    txtMunicipio.current.value = "";
    txtCiudad.current.value = "";

    cmbNacionalidad.current.value = "";
    txtCedRes.current.value = "";
    cmbSexo.current.value = "";
    txtFechaNac.current.value = "";
    txtNomResp.current.value = "";
    txtApeResp.current.value = "";
    txtDireccion.current.value = "";
    txtEmail.current.value = "";
    txtTlf1.current.value = "";
    txtTlf2.current.value = "";
    txtIrsl.current.value = "";
    cmbGrupoCliente.current.value = "";
    txtRetencion.current.checked = false;

    setSelect(1);
    setNacnalidad();
  };

  const onChangeValidar = () => {
    let valorcredt = txtMontoCredito.current.value.trim() !== "" ? parseFloat(txtMontoCredito.current.value.trim()) : 0.00;
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      let nom;
      nom = select === 1 ? "Nombre/Razón Social" : "Nombres y Apellidos";

      let ced;
      ced = select === 1 ? "R.I.F" : "Cédula";

      if (txtStatus.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Seleccione el Estatus del Proveedor",
          icono: "informacion",
        });
        txtStatus.current.focus();
        sigue = false;
      } else if (txtRazon.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "El campo" + " " + nom + " " + "no debe ir Vacio",
          icono: "informacion",
        });
        txtRazon.current.focus();
        sigue = false;
      } else if (txtDirClient.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Describa la Dirección del Proveedor",
          icono: "informacion",
        });
        txtDirClient.current.focus();
        sigue = false;
      } else if (txtEstado.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Seleccione el Estado del Proveedor",
          icono: "informacion",
        });
        txtEstado.current.focus();
        sigue = false;
      } else if (txtMunicipio.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Seleccione el Municipio del Proveedor",
          icono: "informacion",
        });
        txtMunicipio.current.focus();
        sigue = false;
      } else if (txtCiudad.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Seleccione la Ciudad del Proveedor",
          icono: "informacion",
        });
        txtCiudad.current.focus();
        sigue = false;
      } else if (txtCedRes.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar el Responsable",
          icono: "informacion",
        });
        txtCedRes.current.focus();
        sigue = false;
      } else if (operacionPer === 1) {
        if (cmbNacionalidad.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar la nacionalidad del responsable",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
          sigue = false;
        } else if (cmbSexo.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe seleccionar el Sexo del responsable",
            icono: "informacion",
          });
          cmbSexo.current.focus();
          sigue = false;
        } else if (txtFechaNac.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar fecha nacimiento del responsable",
            icono: "informacion",
          });
          txtFechaNac.current.focus();
          sigue = false;
        } else if (txtNomResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el nombre del responsable",
            icono: "informacion",
          });
          txtNomResp.current.focus();
          sigue = false;
        } else if (txtApeResp.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar el apellido del responsable",
            icono: "informacion",
          });
          txtApeResp.current.focus();
          sigue = false;
        } else if (txtDireccion.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe ingresar la dirección del responsable",
            icono: "informacion",
          });
          txtDireccion.current.focus();
          sigue = false;
        }
      } else if (txtLimtCredito.current.checked !== false && valorcredt <= 0) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe ingresar un monto válido para el Limite crédito",
          icono: "informacion",
        });
        txtMontoCredito.current.focus();
        sigue = false;
      }
    }

    if (sigue) {
      var cliente = [];
      var repre = [];
      cliente.push({
        idagente: operacion === 1 ? 0 : txtId.current.value,
        nombre: txtRazon.current.value.toUpperCase().trim(),
        direccion: txtDirClient.current.value.toUpperCase().trim(),
        tipoper: chkNatural.current.checked ? 0 : 1,
        rif: nacnalidad + txtRif.current.value,
        reprelegal: cmbNacionalidad.current.value + txtCedRes.current.value,
        telefono: txtTlf1Client.current.value,
        celular: txtTlf2Client.current.value,
        email: txtEmailClient.current.value.toUpperCase().trim(),
        cliente: true,
        statuscliente: txtStatus.current.value.trim(),
        estado: txtEstado.current.value.trim(),
        municipio: txtMunicipio.current.value.trim(),
        ciudad: txtCiudad.current.value.trim(),
        islr: txtIrsl.current.value.trim(),
        grupcli: cmbGrupoCliente.current.value.trim(),
        agenteretencion: txtRetencion.current.checked ? true : false,
        limitecredito: txtLimtCredito.current.checked ? true : false,
        montocredito: valorcredt,
        oferta: valoferta,
      });
      repre.push({
        cedula: parseInt(txtCedRes.current.value),
        correoe: txtEmail.current.value.toUpperCase().trim(),
        tlf1: txtTlf1.current.value.trim(),
        tlf2: txtTlf2.current.value.trim(),
        apellidos: txtApeResp.current.value.toUpperCase().trim(),
        direccion: txtDireccion.current.value.toUpperCase().trim(),
        fnacimiento: txtFechaNac.current.value.trim(),
        nacionalidad: cmbNacionalidad.current.value.trim(),
        nombres: txtNomResp.current.value.toUpperCase().trim(),
        sexo: cmbSexo.current.value.trim(),
      });
      setBody({
        operacionper: operacionPer,
        agente: cliente,
        repre: repre,
        client: [],
      });

      let msg = "";
      if (operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const procesarRegistro = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/agente/actualizar/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
          seleccionarTotalesClientes();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_rif_key"'
          ) {
            mensaje = "Ya existe un Registro con este rif";
          } else if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "agente_email_key"'
          ) {
            mensaje = "Ya existe un Registro con este correo";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const datosPro = (rif) => {
    let campos = "*";
    let nomtab = "agente";
    let nomid = "rif";
    let nomid2 = "cliente";
    let id = rif;
    let endpoint = "";

    if (!botones.incluir) {
      endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    } else {
      endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;
    }

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data !== "") {
            if (
              botones.incluir === false &&
              response.data.cliente &&
              response.data.rif === valrif
            ) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "¡El Cliente con el N° de Cédula o RIF" +
                  " " +
                  response.data.rif +
                  " " +
                  "ya Existe!",
                icono: "informacion",
              });
              txtId.current.value = "";
              txtStatus.current.value = "";
              txtRazon.current.value = "";
              txtDirClient.current.value = "";
              txtEmailClient.current.value = "";
              txtTlf1Client.current.value = "";
              txtTlf2Client.current.value = "";
              txtEstado.current.value = "";
              txtMunicipio.current.value = "";
              txtCiudad.current.value = "";
              txtRif.current.value = "";
              cmbRif.current.value = "--";

              cmbNacionalidad.current.value = "";
              txtCedRes.current.value = "";

              muni = "";
              ciu = "";

              cmbSexo.current.value = "";
              txtFechaNac.current.value = "";
              txtNomResp.current.value = "";
              txtApeResp.current.value = "";
              txtDireccion.current.value = "";
              txtEmail.current.value = "";
              txtTlf1.current.value = "";
              txtTlf2.current.value = "";
            } else {
              txtId.current.value = response.data.idagente;
              txtStatus.current.value = response.data.statuscliente;
              txtRazon.current.value =
                response.data.nombre && response.data.nombre.trim();
              txtDirClient.current.value =
                response.data.direccion && response.data.direccion.trim();
              txtEmailClient.current.value =
                response.data.email && response.data.email.trim();
              txtTlf1Client.current.value =
                response.data.telefono && response.data.telefono.trim();
              txtTlf2Client.current.value =
                response.data.celular && response.data.celular.trim();
              txtEstado.current.value = response.data.estado;
              txtMunicipio.current.value = response.data.municipio;
              txtCiudad.current.value = response.data.ciudad;
              txtIrsl.current.value = response.data.islr;
              cmbGrupoCliente.current.value = response.data.grupcli;

              txtRetencion.current.checked = response.data.agenteretencion;

              cmbNacionalidad.current.value =
                response.data.reprelegal.substring(0, 1);
              txtCedRes.current.value = response.data.reprelegal.substring(
                1,
                12
              );

              muni = response.data.municipio.trim();
              ciu = response.data.ciudad.trim();

              if (response.data.oferta !== 0) {
                txtOFerta.current.checked = true;
                setValoferta(response.data.oferta);
              } else {
                txtOFerta.current.checked = false;
                setValoferta(0);
              }

              selectMunicipios(response.data.estado.trim());
              selectCiudad(response.data.municipio.trim());
              datosRes();
              setNacnalidad(response.data.rif.substring(0, 1));

              let tip = response.data.tipoper;
              if (tip === 1) {
                chkJuridico.current.checked = true;
                chkNatural.current.checked = false;
              } else {
                chkNatural.current.checked = true;
                chkJuridico.current.checked = false;
              }

              setSelect(response.data.tipoper);

              if (operacion === 4) {
                setAcept(true);
                setIdclient(response.data.idagente);
                setBuscaclient(1);
                setRifclient(response.data.rif);
              } else if (operacion === 2 || operacion === 1) {
                setAcept(false);
                setOps(2);
                setHabilitado(false);
                setHabilitadoNU(false);
                setBotones({ ...botones, catalogoper: false });
                setIdclient(0);
                setBuscaclient(0);
                setRifclient(null);
              } else if (operacion === 3) {
                setAcept(false);
              }
            }
          } else {
            if (operacion === 4 || operacion === 3 || operacion === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Notificación",
                texto:
                  "¡El Cliente con el N° de Cédula o RIF" +
                  " " +
                  txtRif.current.value +
                  " " +
                  "No Existe!",
                icono: "error",
              });
              txtId.current.value = "";
              txtStatus.current.value = "";
              txtRazon.current.value = "";
              txtDirClient.current.value = "";
              txtEmailClient.current.value = "";
              txtTlf1Client.current.value = "";
              txtTlf2Client.current.value = "";
              txtEstado.current.value = "";
              txtMunicipio.current.value = "";
              txtCiudad.current.value = "";
              txtRif.current.value = "";
              cmbRif.current.value = "--";

              cmbNacionalidad.current.value = "";
              txtCedRes.current.value = "";

              muni = "";
              ciu = "";

              cmbSexo.current.value = "";
              txtFechaNac.current.value = "";
              txtNomResp.current.value = "";
              txtApeResp.current.value = "";
              txtDireccion.current.value = "";
              txtEmail.current.value = "";
              txtTlf1.current.value = "";
              txtTlf2.current.value = "";
              txtOFerta.current.checked = false;
              setOps(1);
              setHabilitado(true);
              setHabilitadoNU(true);
              setBotones({ catalogoper: true, aceptar: true });
            }

            txtRazon.current.focus();
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCliente = (event) => {
    event.preventDefault();
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (cmbRif.current.value !== "") {
          if (operacion !== 2) {
            datosPro(nacnalidad + event.target.value);
          }
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "Debe Seleccionar el Tipo de Nacionalidad",
            icono: "informacion",
          });
          cmbRif.current.focus();
        }
      }
    }
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        if (cmbNacionalidad.current.value !== "") {
          datosRes();
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "debe seleccionar la nacionalidad",
            icono: "informacion",
          });
          cmbNacionalidad.current.focus();
        }
      } else {
        cmbNacionalidad.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
      }
    }
  };

  const onChangeCliente = (e) => {
    if (e.target.name === "estado") {
      setMunicipios([]);
      setCiudades([]);
      if (e.target.value !== "") {
        selectMunicipios(e.target.value);
      }
    } else if (e.target.name === "municipio") {
      setCiudades([]);
      if (e.target.value !== "") {
        selectCiudad(e.target.value);
      }
    } else if (e.target.name === "tipoper") {
      if (chkNatural.current.checked) {
        setSelect(0);
      } else if (chkJuridico.current.checked) {
        setSelect(1);
      }
    } else if (e.target.name === "cmbrif") {
      let nac = cmbRif.current.value;
      txtRif.current.value = "";
      txtRif.current.focus();
      setNacnalidad(nac);
    }
  };

  const onChange = (e) => {
    let n;
    let r;

    if (
      e.target.name === "correoe" ||
      e.target.name === "apellidos" ||
      e.target.name === "direccion" ||
      e.target.name === "nombres" ||
      e.target.name === "descripcion"
    ) {
      e.target.value = e.target.value;
    } else if (
      e.target.name === "nacionalidad" &&
      txtCedRes.current.value !== ""
    ) {
      if (e.target.value !== "") {
        datosRes();
      } else {
        txtCedRes.current.value = "";
        cmbSexo.current.value = "";
        txtFechaNac.current.value = "";
        txtNomResp.current.value = "";
        txtApeResp.current.value = "";
        txtDireccion.current.value = "";
        txtEmail.current.value = "";
        txtTlf1.current.value = "";
        txtTlf2.current.value = "";
        setHabilitadoNU(true);
      }
    } else if (e.target.name === "cedula") {
      n = cmbRif.current.value;
      r = txtRif.current.value;
    }
    valrif = n + r;
  };

  const onChangeCredit = (e) => {
    if (e.target.name === "Credit") {
      if (e.target.checked) {
        setValcredt(1);
      } else {
        setValcredt(0);
        txtMontoCredito.current.value = 0.00;
      }
    }
  }

  const onChangeOFerta = (e) => {
    if (e.target.name === "Oferta") {
      if (e.target.checked) {
        setValoferta(1);
      } else {
        setValoferta(0);
      }
    }
  }

  const onCatalogoCliente = (values) => {
    setCatalogoCliente(false);
    let valordelcredto = formatMoneda(
      (values.montocredito)
        .toString()
        .replace(",", "")
        .replace(".", ","),
      ",",
      ".",
      2
    );
    if (values.limitecredito !== false) {
      setValcredt(1);
      setValorCredito(valordelcredto);
    } else {
      setValcredt(0);
      setValorCredito(parseFloat(0));
    }
    txtRazon.current.value = values.nombre;
    cmbRif.current.value = values.rif.substring(0, 1);
    txtRif.current.value = values.rifs;
    cmbNacionalidad.current.value = values.reprelegal.substring(0, 1);
    txtCedRes.current.value = values.repre;
    txtLimtCredito.current.checked = values.limitecredito;
    setNacnalidad(values.rif.substring(0, 1));
    datosPro(values.rif);

    if (operacion === 4) {
      setIdclient(values.idagente);
      setBuscaclient(1);
      setRifclient(values.rif);
    } else {
      setIdclient(0);
      setBuscaclient(0);
      setRifclient(null);
    }

    if (!botones.modificar) {
      setBotones({ ...botones, catalogoper: false });
    }
    txtMontoCredito.current.value = parseFloat(values.montocredito);
  };

  const onCatalogoPersona = (values) => {
    setCatalogoPersona(false);
    setHabilitadoNU(true);
    setOperacionPer(0);
    cmbNacionalidad.current.value = values.nacPer;
    txtCedRes.current.value = values.cedPer;
    cmbSexo.current.value = values.sexoPer;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    txtNomResp.current.value = values.nomPer;
    txtApeResp.current.value = values.apePer;
    txtDireccion.current.value = values.direPer;
    txtEmail.current.value = values.correoPer;
    txtTlf1.current.value = values.tlf1Per;
    txtTlf2.current.value = values.tlf2Per;
  };

  const onBotones = (op) => (e) => {
    e.preventDefault();

    if (op === 1) {
      if (accbtnclientes && accbtnclientes.toString().substring(0, 1) === "1") {
        setVisibleBtn(1);
        setTituloHeader("Incluir Cliente.");
        setHabilitado(false);
        setOps(2);
        setAcept(false);
        setOperacion(1);
        setBotones({
          incluir: false,
          consultar: true,
          modificar: true,
          eliminar: true,
          cancelar: false,
          catalogo: true,
          catalogoper: false,
        });
        setActivo(false);
        setActivob(true);
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 2) {
      if (accbtnclientes && accbtnclientes.toString().substring(1, 2) === "1") {
        setVisibleBtn(1);
        setTituloHeader("Editar Cliente.");
        setOperacion(2);
        setOps(1);
        setHabilitado(true);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: false,
          eliminar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        setActivo(false);
        setActivob(false);
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 3) {
      if (accbtnclientes && accbtnclientes.toString().substring(3, 4) === "1") {
        setVisibleBtn(1);
        setTituloHeader("Eliminar Cliente.");
        setOperacion(3);
        setHabilitado(true);
        setOps(1);
        setBotones({
          incluir: true,
          consultar: true,
          modificar: true,
          eliminar: false,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        setActivo(false);
        setActivob(false);
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 4) {
      if (accbtnclientes && accbtnclientes.toString().substring(2, 3) === "1") {
        setVisibleBtn(1);
        setTituloHeader("Consultar Cliente.");
        setOperacion(4);
        setHabilitado(true);
        setOps(1);
        setBotones({
          incluir: true,
          consultar: false,
          modificar: true,
          eliminar: true,
          cancelar: false,
          catalogo: false,
          catalogoper: true,
        });
        setActivo(false);
        setActivob(false);
        txtRif.current.focus();
      } else {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "¡No Posee Permiso para Realizar esta Acción!",
          icono: "error",
        });
      }
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      setVisibleBtn(0);
      blanquear();
    }
  };

  const seleccionarTotalesClientes = () => {
    let campos = "idagente, statuscliente as status";
    let nomtab = "agente";
    let nomid = "cliente";
    let orden = "idagente desc";
    let endpoint = `${op.conexion}/api/consulta/modeliorder?campos=${campos}&id=true&nomtab=${nomtab}&nomid=${nomid}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let activo = 0;
            let inactivo = 0;
            for (let i = 0; i < response.data.length; i++) {
              if (parseInt(response.data[i].status) === 51) {
                activo = activo + 1;
              } else {
                inactivo = inactivo + 1;
              }
            }

            setTitulo("Clientes");
            setTotalr(response.data.length);
            setTotalact(activo);
            setTotalinc(inactivo);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarTotalesClientes();
  }, []);

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12 py-2" style={{ margin: 0 }}>
          <div className="col-md-9 py-1 mx-auto card shadow ">
            <div className="col-md-12 row mx-auto  rounded">
              <div className="col-md-12 border-azul rounded py-2 row mx-auto mb-3 mt-2 azulGradiant shadow text-light">
                <div className="col-p-3 mb-1">
                  <h3>{tituloHeader}</h3>
                </div>
                <div className="col-p-2 mi-auto">
                  <button
                    ref={btnAcepta}
                    onClick={imprimir}
                    className="btn btn-sm col ml-1 rounded-pill btn-info h-25p f-10"
                  >
                    <i className="fas fa-print"> CLIENTES</i>
                  </button>
                </div>
                <div className="col-p-1 mi-auto">
                  <a href="/inicio" className="text-light">
                    <i className="fas fa-times mx-2"></i>
                    <span className="fw-bold">Salir</span>
                  </a>
                </div>
              </div>
              <div className="col-md-12" style={{ fontSizeAdjust: "0.6" }}>
                <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                  <legend
                    className="float-none w-auto fw-bold m-0"
                    style={{ fontSize: "15px" }}
                  >
                    Datos del Cliente
                  </legend>
                  <input
                    ref={txtId}
                    autoComplete="off"
                    type="hidden"
                    className="form-control"
                    name="idagente"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />

                  <div className="mb-1 col-pd-260">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        {select === 1 ? "R.I.F" : "CEDULA"}{" "}
                      </label>

                      {select === 1 ? (
                        <select
                          disabled={activo}
                          ref={cmbRif}
                          name="cmbrif"
                          onChange={onChangeCliente}
                          value={nacnalidad}
                          className="col-sm-3 col-3 px-2 form-select form-control-sm"
                        >
                          <option value="">-</option>
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="J">
                            J
                          </option>
                          <option key="2" value="G">
                            G
                          </option>
                          <option key="3" value="P">
                            P
                          </option>
                        </select>
                      ) : (
                        <select
                          disabled={activo}
                          ref={cmbRif}
                          name="cmbrif"
                          onChange={onChangeCliente}
                          value={nacnalidad}
                          className="col-sm-3 col-3 px-2 form-select form-control-sm"
                        >
                          <option value="">-</option>
                          <option key="0" value="V">
                            V
                          </option>
                          <option key="1" value="E">
                            E
                          </option>
                        </select>
                      )}

                      <input
                        ref={txtRif}
                        autoComplete="off"
                        maxLength={9}
                        type="text"
                        disabled={activo}
                        className="form-control col-9 px-1 fs-6"
                        name="cedula"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onKeyUp={validarCliente}
                        onBlur={validarCliente}
                        onChange={onChange}
                      />
                      <button
                        disabled={activob}
                        type="button"
                        onClick={() => setCatalogoCliente(true)}
                        className="btn btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>

                  <div className="mt-15m ml-auto col-pd-280">
                    <fieldset className="row col-sm-12 mx-auto border-azul rounded mb-1">
                      <legend
                        className="float-none m-0 w-auto"
                        style={{ fontSize: "14px" }}
                      >
                        TIPO PERSONA:
                      </legend>

                      <div className="col-5 mr-auto">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={ops === 1 ? true : activo}
                            name="tipoper"
                            value="1"
                            ref={chkNatural}
                            onChange={onChangeCliente}
                            id="tipoper"
                            type="radio"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleRadi4"
                          >
                            Natural
                          </label>
                        </div>
                      </div>

                      <div className="col-5 ml-auto">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            disabled={ops === 1 ? true : activo}
                            name="tipoper"
                            value="2"
                            ref={chkJuridico}
                            onChange={onChangeCliente}
                            id="tipoper"
                            defaultChecked={true}
                            type="radio"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="exampleRadi5"
                          >
                            Juridico
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>

                  <div className="col-pd-200 ml-auto mb-1">
                    <div className="form-check">
                      <input
                        ref={txtOFerta}
                        disabled={habilitado}
                        className="form-check-input"
                        type="checkbox"
                        name="Oferta"
                        onChange={onChangeOFerta}
                        value=""
                        id="flexCheckDefault3"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault3"
                        style={{ fontSize: "13px" }}
                      >
                        OFERTA
                      </label>
                    </div>
                  </div>

                  <div className="col-pd-200 ml-auto mb-1">
                    <div className="input-group input-group-sm">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        ESTATUS:
                      </label>
                      <select
                        ref={txtStatus}
                        disabled={ops === 1 ? true : activo}
                        className="form-select form-select-sm text-uppercase px-1"
                        aria-label=".form-select-sm example"
                      >
                        <option value="">Seleccione</option>
                        <option value="51">Activo</option>
                        <option value="52">Inactivo</option>
                      </select>
                    </div>
                  </div>

                  <div className="input-group input-group-sm mb-1 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      {select === 1
                        ? "NOMBRE/RAZON SOCIAL"
                        : "NOMBRES Y APELLIDOS"}
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtRazon}
                      disabled={habilitado}
                      name="nombres"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm mb-1 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:
                    </label>
                    <textarea
                      type="area"
                      autoComplete="off"
                      ref={txtDirClient}
                      disabled={habilitado}
                      name="direccion"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      style={{ height: 40 }}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-1 col-pd-250 px-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      ESTADO:
                    </label>
                    <select
                      ref={txtEstado}
                      disabled={habilitado}
                      onChange={onChangeCliente}
                      name="estado"
                      idciudad="estado"
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">SELECCIONE</option>
                      {estados &&
                        estados.map((item, index) => (
                          <option key={index} value={item.idestado}>
                            {item.nombre}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-1 col-md-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      MUNICIPIO:
                    </label>
                    <select
                      ref={txtMunicipio}
                      disabled={habilitado}
                      onChange={onChangeCliente}
                      name="municipio"
                      id="municipio"
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">SELECCIONE</option>
                      {municipios &&
                        municipios.map((item, index) => (
                          <option key={index} value={item.idmunicipio}>
                            {item.nombre}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-1 col-md-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      CIUDAD:
                    </label>
                    <select
                      ref={txtCiudad}
                      disabled={habilitado}
                      name="ciudad"
                      id="ciudad"
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">SELECCIONE</option>
                      {ciudades &&
                        ciudades.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {item.nombre}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group input-group-sm mb-1 col-pd-200 px-2 ml-auto">
                    <label
                      className="input-group-text px-1"
                      id="inputGroup-sizing-sm"
                    >
                      CELULAR:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={11}
                      ref={txtTlf2Client}
                      disabled={habilitado}
                      className="form-control px-1 fs-6"
                      name="tlf2"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>

                  <div className="input-group input-group-sm mb-1 col-md-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      EMAIL:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtEmailClient}
                      disabled={habilitado}
                      className="form-control text-uppercase fs-6"
                      name="correoe"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm mb-1 col-pd-210 px-1">
                    <label
                      className="input-group-text px-1"
                      id="inputGroup-sizing-sm px-1"
                    >
                      TELEFONO:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={11}
                      ref={txtTlf1Client}
                      disabled={habilitado}
                      className="form-control px-1 fs-6"
                      name="tlf1"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>
                </fieldset>
              </div>
              <div className="col-md-12" style={{ fontSizeAdjust: "0.6" }}>
                <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "15px" }}
                  >
                    Responsable
                  </legend>

                  <div className="col-pd-270 px-2">
                    <div className="input-group input-group-sm mb-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CEDULA:
                      </label>
                      <select
                        ref={cmbNacionalidad}
                        name="nacionalidad"
                        className="form-select form-select-sm col-3 px-2"
                        disabled={habilitado}
                        aria-label=".form-select-sm example"
                        onChange={onChange}
                      >
                        <option value="">--</option>
                        <option value="V">V</option>
                        <option value="E">E</option>
                      </select>
                      <input
                        ref={txtCedRes}
                        maxLength={8}
                        autoComplete="off"
                        type="text"
                        disabled={habilitado}
                        className="form-control col-7 px-1 fs-6"
                        name="cedula"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onKeyUp={validarPersona}
                        onBlur={validarPersona}
                        onChange={onChange}
                      />
                      <button
                        disabled={botones.catalogoper}
                        type="button"
                        onClick={() => setCatalogoPersona(true)}
                        className="btn btn-success"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </div>
                  </div>

                  <div className="col-pd-140 ml-auto">
                    <div className="input-group input-group-sm mb-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        SEXO:
                      </label>
                      <select
                        ref={cmbSexo}
                        className="form-select form-select-sm"
                        name="sexo"
                        disabled={habilitadoNU}
                        onChange={onChange}
                        aria-label=".form-select-sm example"
                      >
                        <option value="">--</option>
                        <option value="M">M</option>
                        <option value="F">F</option>
                      </select>
                    </div>
                  </div>

                  <div className="col-pd-330 ml-auto px-2">
                    <div className="input-group input-group-sm mb-2">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        FECHA DE NACIMIENTO
                      </label>
                      <input
                        type="date"
                        ref={txtFechaNac}
                        max={fechaTope}
                        className="form-control text-center px-1 text-uppercase fs-6"
                        name="fnacimiento"
                        aria-label="Sizing example input"
                        onChange={onChange}
                        disabled={habilitadoNU}
                        aria-describedby="inputGroup-sizing-sm"
                      />
                    </div>
                  </div>

                  <div className="input-group input-group-sm mb-2 col-md-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      NOMBRES:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtNomResp}
                      name="nombres"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      APELLIDOS:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtApeResp}
                      name="apellidos"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      DIRECCION:
                    </label>
                    <textarea
                      type="area"
                      autoComplete="off"
                      ref={txtDireccion}
                      name="direccion"
                      className="form-control text-uppercase fs-6"
                      onChange={onChange}
                      aria-label="Sizing example input"
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                      style={{ height: 40 }}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-md-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      EMAIL:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      ref={txtEmail}
                      className="form-control text-uppercase fs-6"
                      name="correoe"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-210 px-1">
                    <label
                      className="input-group-text px-1"
                      id="inputGroup-sizing-sm"
                    >
                      TELEFONO:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={11}
                      ref={txtTlf1}
                      className="form-control px-1 fs-6"
                      name="tlf1"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>
                  <div className="input-group input-group-sm mb-2 col-pd-210">
                    <label
                      className="input-group-text px-1"
                      id="inputGroup-sizing-sm"
                    >
                      CELULAR:
                    </label>
                    <input
                      type="text"
                      autoComplete="off"
                      maxLength={11}
                      ref={txtTlf2}
                      className="form-control px-1 fs-6"
                      name="tlf2"
                      aria-label="Sizing example input"
                      onChange={onChange}
                      disabled={habilitadoNU}
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={handleInputNumChange}
                    />
                  </div>
                </fieldset>
              </div>

              <div className="col-md-12" style={{ fontSizeAdjust: "0.6" }}>
                <fieldset className=" row col-sm-12 mx-auto border-azul rounded">
                  <legend
                    className="float-none w-auto fw-bold"
                    style={{ fontSize: "15px" }}
                  >
                    Otros Datos
                  </legend>

                  <div className="input-group input-group-sm mb-2 col-pd-230">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      % RETENCION I.S.L.R:
                    </label>
                    <input
                      type="text"
                      ref={txtIrsl}
                      disabled={habilitado}
                      maxLength={2}
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="input-group input-group-sm mb-2 col-pd-270 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      GRUPO DE CLIENTE:
                    </label>
                    <select
                      ref={cmbGrupoCliente}
                      disabled={habilitado}
                      className="form-select form-select-sm text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">SELECCIONE</option>
                      <option value="1">VIP</option>
                      <option value="2">REGULAR</option>
                    </select>
                  </div>

                  <div className="col-md-2 ml-2">
                    <div className="form-check">
                      <input
                        ref={txtRetencion}
                        disabled={habilitado}
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault"
                        style={{ fontSize: "13px" }}
                      >
                        CONTRIBUYENTE ESPECIAL
                      </label>
                    </div>
                  </div>

                  <div className="col-md-2">
                    <div className="form-check">
                      <input
                        ref={txtLimtCredito}
                        disabled={habilitado}
                        className="form-check-input"
                        type="checkbox"
                        name="Credit"
                        onChange={onChangeCredit}
                        value=""
                        id="flexCheckDefault2"
                      />
                      <label
                        className="form-check-label"
                        htmlFor="flexCheckDefault2"
                        style={{ fontSize: "13px" }}
                      >
                        LIMITE DE CREDITO
                      </label>
                    </div>
                  </div>
                  {valcredt !== 0 ? (
                    <div className="col-md-2 px-1">
                      <div className="input-group input-group-sm mb-2 col">
                        <span className="input-group-text text-black text-bold">MONTO:</span>
                        <input type="text" className="form-control fs-6 text-right" ref={txtMontoCredito} disabled={habilitado} defaultValue={valorCredito} maxLength={15} aria-label="Amount (to the nearest dollar)" placeholder="0,00" onKeyUp={handleInputMonChange} onBlur={handleInputMonChange} />
                        <span className="input-group-text">$</span>
                      </div>
                    </div>) : <input type="hidden" ref={txtMontoCredito} value={0.00} />}
                </fieldset>
              </div>

              <div className="col-md-12 py-1">
                {visibleBtn === 0 ? (
                  <div className="col-pd-botones">
                    <div className="col-md-12 row m-0">
                      <button
                        disabled={botones.incluir}
                        onClick={onBotones(1)}
                        className="btn btn-sm col ml-1 mb-1 btn-primary rounded-pill"
                        title="Incluir Almacen"
                      >
                        <i className="fas fa-plus"> Incluir </i>{" "}
                      </button>
                      <button
                        disabled={botones.consultar}
                        onClick={onBotones(4)}
                        className="btn btn-sm col ml-1 mb-1 btn-info rounded-pill"
                        title="Consultar Almacen"
                      >
                        <i className="fas fa-eye"> Consultar</i>{" "}
                      </button>
                      <button
                        disabled={botones.modificar}
                        onClick={onBotones(2)}
                        className="btn btn-sm col ml-1 mb-1 btn-warning rounded-pill"
                        title="Modificar Almacen"
                      >
                        <i className="fa fa-edit"> Modificar</i>{" "}
                      </button>
                      <button
                        disabled={botones.eliminar}
                        onClick={onBotones(3)}
                        className="btn btn-sm col ml-1 mb-1 btn-danger rounded-pill"
                        title="Eliminar Almacen"
                      >
                        <i className="fa fa-trash"> Eliminar</i>{" "}
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="col-pd-botonesd row m-0 ml-auto">
                    <button
                      ref={btnAcepta}
                      disabled={acept}
                      onClick={onBotones(5)}
                      className="btn btn-sm col ml-1 rounded-pill btn-success"
                    >
                      <i className="fas fa-check-circle"> Aceptar</i>
                    </button>
                    <button
                      ref={btnCancela}
                      disabled={botones.cancelar}
                      onClick={onBotones(6)}
                      className="btn btn-danger col ml-1 btn-sm rounded-pill"
                    >
                      <i className="fas fa-window-close"> Cancelar</i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-3 oculto">
            <CartasProveedores
              totalr={totalr}
              totalact={totalact}
              totalinc={totalinc}
              titulo={titulo}
              idcliente={idclient}
              valida={buscaclient}
              rifclient={rifclient}
            />
          </div>
        </div>
      </div>
      {/*  */}
      <CatalogoCliente
        show={catalogoCliente}
        nomid="cliente"
        onHideCancelar={() => setCatalogoCliente(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />
      <CatalogoPersona
        show={catalogoPersona}
        onHideCancelaCatPer={() => setCatalogoPersona(false)}
        onHideAceptaCatPer={onCatalogoPersona}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default TablaClientes;



// WEBPACK FOOTER //
// ./src/components/ventas/tablaClientes.js